import Fe from '../ui/FormElement';

export default [
    Fe.Text("tag", "Tag"),
    Fe.Text("type", "Type"),
]
